import { Order } from "pages/vendor/Orders"
import React, { useMemo } from "react"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import TableContainer from "components/Common/TableContainer"
import { PaymentStatus as PaymentStatusEnum } from "./ordersType"
import { OrderStatus } from "./Components/OrderStatus"
import { PaymentState } from "./Components/PaymentStatus"
import { useTranslation } from "react-i18next"
import OrderActionMenu from "pages/vendor/Orders/Components/OrderActionMenu"

// Helper function to convert isPaid to PaymentStatus
const isPaidToPaymentStatus = (isPaid: boolean): PaymentStatusEnum => {
  return isPaid ? PaymentStatusEnum.paid : PaymentStatusEnum.unpaid
}

// Helper function to format date to '23 jun, 2022' format
const formatDate = (dateString: string): string => {
  if (!dateString) return "__"
  const date = new Date(dateString)
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  const day = date.getDate()
  const month = months[date.getMonth()]
  const year = date.getFullYear()
  return `${day} ${month}, ${year}`
}

interface OrdersTableProps {
  orders: Order[]
  isAllChecked: boolean
  checkedOrders: Order[]
  toggleAllOrders: () => void
  checkedOrderHandler: (order: Order) => void
  acceptHandler: (order: Order) => void
  rejectHandler: (order: Order) => void
  viewDetailsHandler: (order: Order) => void
  location?: any
}

const OrdersTable: React.FC<OrdersTableProps> = ({
  orders,
  isAllChecked,
  checkedOrders,
  toggleAllOrders,
  checkedOrderHandler,
  acceptHandler,
  rejectHandler,
  viewDetailsHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllOrders}
            checked={isAllChecked}
          />
        ),
        accessor: "select",
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <input
              onClick={() => checkedOrderHandler(cellProps.row.original)}
              checked={Boolean(
                checkedOrders.find(o => o.id === cellProps.row.original.id)
              )}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("orders_orderId"),
        accessor: "id",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{cellProps.row.original.id}</>
        },
      },
      {
        Header: t("common_createdDate"),
        accessor: "issueTime",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{formatDate(cellProps.row.original.issueTime)}</>
        },
      },
      {
        Header: t("common_createdBy"),
        accessor: "customerName",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <>
              <i className="bx bx-user-circle me-1" />
              {cellProps.row.original.customerName || "__"}
            </>
          )
        },
      },
      {
        Header: t("orders_status"),
        accessor: "statusName",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return (
            <OrderStatus orderStatus={cellProps.row.original.statusName} />
          )
        },
      },
      {
        Header: t("orders_value"),
        accessor: "total",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <>{cellProps.row.original.total || "__"}</>
        },
      },
      {
        Header: t("orders_paymentStatus"),
        accessor: "isPaid",
        filterable: true,
        Cell: (cellProps: { row: { original: Order } }) => {
          return <PaymentState payment={isPaidToPaymentStatus(cellProps.row.original.isPaid)} />
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Order } }) => {
          const order = cellProps.row.original
          return (
            <OrderActionMenu
              order={order}
              acceptHandler={acceptHandler}
              rejectHandler={rejectHandler}
              viewDetailsHandler={viewDetailsHandler}
            />
            
          )
        },
      },
    ],
    [orders, t, checkedOrders]
  )

  return (
    <TableContainer
      columns={columns}
      data={orders}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={""}
      customPageSizeOptions={undefined}
    />
  )
}

OrdersTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(OrdersTable))
